module.exports = __webpack_public_path__ + "img/paw-new.43b4ebdf.svg";